<template>
  <header
      class="sticky top-0 z-[1000] bg-white/80 backdrop-saturate-180 backdrop-blur border-b border-black/5"
  >
    <div
        class="h-16 px-[200px] flex items-center justify-between max-[768px]:h-14 max-[768px]:px-4"
    >
      <!-- 左侧：品牌 + 导航 -->
      <div class="flex items-center justify-between gap-5 w-full">
        <div class="flex items-center gap-2.5">
          <img
              class="w-7 h-7 rounded-md"
              src="/favicon.ico"
              alt="七云智联"
          />
          <span
              class="font-bold text-[18px] tracking-wide bg-gradient-to-tr from-indigo-400 to-blue-500 bg-clip-text text-transparent"
          >
            七云智联
          </span>
        </div>

        <nav
            class="flex items-center gap-[50px] max-[768px]:hidden"
        >
          <a
              :class="[
                'text-[#444] no-underline text-[14px] py-2 px-1 rounded-md transition-colors hover:text-blue-500 hover:bg-indigo-400/10',
                currentHash === '#index' && 'text-blue-500 font-semibold'
              ]"
              href="#index"
          >
            首页
          </a>

          <a
              :class="[
                'text-[#444] no-underline text-[14px] py-2 px-1 rounded-md transition-colors hover:text-blue-500 hover:bg-indigo-400/10',
                currentHash === '#business' && 'text-blue-500 font-semibold'
              ]"
              href="#business"
          >
            净水器管家
          </a>
          
          <a
              :class="[
                'text-[#444] no-underline text-[14px] py-2 px-1 rounded-md transition-colors hover:text-blue-500 hover:bg-indigo-400/10',
                currentHash === '#about' && 'text-blue-500 font-semibold'
              ]"
              href="#about"
          >
            物联网主板
          </a>

          <a
              :class="[
                'text-[#444] no-underline text-[14px] py-2 px-1 rounded-md transition-colors hover:text-blue-500 hover:bg-indigo-400/10',
                currentHash === '#ecosystem' && 'text-blue-500 font-semibold'
              ]"
              href="#ecosystem"
          >
            客户合作
          </a>



          <a
              :class="[
                'text-[#444] no-underline text-[14px] py-2 px-1 rounded-md transition-colors hover:text-blue-500 hover:bg-indigo-400/10',
                currentHash === '#contact' && 'text-blue-500 font-semibold'
              ]"
              href="#contact"
          >
            联系方式
          </a>
        </nav>
      </div>

      <!-- 右侧：操作 -->
      <div class="flex items-center ml-6 w-[100px]">
        <a
            href="#contact"
            class="inline-flex flex-col md:flex-row items-center justify-center
           h-auto md:h-9 px-3.5 py-2 rounded-[10px]
           text-white text-[14px] text-center leading-tight
           bg-gradient-to-tr from-indigo-400 to-purple-500
           shadow-[0_6px_18px_rgba(102,126,234,0.25)]
           hover:opacity-95"
        >
          <span>立即</span>
          <span>咨询</span>
        </a>
      </div>

    </div>
  </header>
</template>

<script setup>
import { onMounted, onBeforeUnmount, ref } from 'vue'

const currentHash = ref(window.location.hash || '')

function handleHashChange() {
  currentHash.value = window.location.hash || ''
}

onMounted(() => {
  window.addEventListener('hashchange', handleHashChange, { passive: true })

  const sectionIds = ['index', 'business', 'ecosystem', 'about', 'contact']
  const headerOffset = 80 // 与吸顶头部高度相匹配
  let ticking = false

  function updateActiveByScroll() {
    ticking = false
    const referenceY = headerOffset + 1
    const candidates = sectionIds
      .map((id) => {
        const el = document.getElementById(id)
        if (!el) return null
        const rect = el.getBoundingClientRect()
        return { id, top: rect.top, bottom: rect.bottom }
      })
      .filter(Boolean)

    // 若已滚动到底部，直接激活最后一个存在的区块，避免因区块偏短而参考线无法命中
    const doc = document.documentElement
    const reachedBottom = Math.ceil(window.scrollY + window.innerHeight) >= doc.scrollHeight
    if (reachedBottom) {
      const lastExisting = [...sectionIds].reverse().find(id => document.getElementById(id))
      if (lastExisting) {
        const bottomHash = `#${lastExisting}`
        if (bottomHash !== currentHash.value) {
          currentHash.value = bottomHash
        }
        return
      }
    }

    // 1) 首选：参考线位于某个 section 内部（top <= refY < bottom）
    const containing = candidates.find(s => s.top <= referenceY && s.bottom > referenceY)
    let activeId = containing ? containing.id : null

    // 2) 退化：若没有，则选择参考线上方最近的 section（bottom <= refY）中的最后一个
    if (!activeId) {
      const above = candidates.filter(s => s.bottom <= referenceY)
      if (above.length) {
        activeId = above[above.length - 1].id
      }
    }

    // 3) 再退：若参考线上方没有任何 section，则选择参考线下方的第一个
    if (!activeId && candidates.length) {
      const below = candidates.filter(s => s.top > referenceY)
      if (below.length) {
        activeId = below[0].id
      }
    }

    const newHash = activeId ? `#${activeId}` : ''
    if (newHash && newHash !== currentHash.value) {
      currentHash.value = newHash
    }
  }

  function onScroll() {
    if (!ticking) {
      ticking = true
      requestAnimationFrame(updateActiveByScroll)
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true })
  // 初始化计算一次
  updateActiveByScroll()

  // 保存引用以便卸载时移除
  // eslint-disable-next-line no-underscore-dangle
  ;(window)._headerNavScrollHandler = onScroll
})

onBeforeUnmount(() => {
  window.removeEventListener('hashchange', handleHashChange)
  // 移除滚动监听
  // eslint-disable-next-line no-underscore-dangle
  const onScroll = (window)._headerNavScrollHandler
  if (onScroll) window.removeEventListener('scroll', onScroll)
})
</script>

<style>

</style>